
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as healthPJTGZk6hPEVO7CVIKDEBV0u6Vu2Z5GL3ufgO_D9tXKUMeta } from "/codebuild/output/src4008751961/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/health.vue?macro=true";
import { default as _91_46_46_46slug_93CftzdTy_Ck7JGo3SernKNvHS286kVN87mxp68fFUpLMMeta } from "/codebuild/output/src4008751961/src/bitbucket.org/magusa/cavu-workspaces/apps/_base/pages/[...slug].vue?macro=true";
import { default as port_45parking3z4t9E9IY15zypN0coXpjnzNnj_45bJq8B9xAUei_sKBgMeta } from "/codebuild/output/src4008751961/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/port-parking.vue?macro=true";
import { default as airport_45hotelsy0FVDbZ_454Vmob_45CdqfsAr1htkMI6cLRR7qAaTR43NW8Meta } from "/codebuild/output/src4008751961/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-hotels.vue?macro=true";
import { default as airport_45parkingqoOG2nrYjCWyppc0ZMe3ewBxO3FwrzDf0JsoSNiJGcAMeta } from "/codebuild/output/src4008751961/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-parking.vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_93vbzUjkKprqemWDnqfoQzN14hMAOQeKIubQfy41jx4m0Meta } from "/codebuild/output/src4008751961/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/hro/[code]-[name]-[IATA].vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_93POsHgOCsgP2Ea45RaWssz8EEJDbOkRAPKVOuaI4SRAIMeta } from "/codebuild/output/src4008751961/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/parking/[code]-[name]-[IATA].vue?macro=true";
import { default as port_45hotels_45with_45parkingN_EtK0B0JuMYdQZ2ykVssv7M2hb31CXszpB3f4mz1JQMeta } from "/codebuild/output/src4008751961/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/port-hotels-with-parking.vue?macro=true";
import { default as airport_45hotels_45with_45parkingXT9Npz7HWBozGJI31JWNciXHfFN19jVBHbo_wxmaq_45AMeta } from "/codebuild/output/src4008751961/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-hotels-with-parking.vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_93OxyUZFK71RO5zclqUNBta1UlgO3bG0yKyXiI_45sSrrOUMeta } from "/codebuild/output/src4008751961/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/hotel-package/[code]-[name]-[IATA].vue?macro=true";
import { default as component_45stubNyGwWrrNAeEQbLx67XD1MnsMWlG8Y8af_45_TBmMjjCqUMeta } from "/codebuild/output/src4008751961/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.0.7_db0@0.3.2_eslint@9.30.0_jiti@2.4.2_1d807c0e19115dcb12ca49115f5ceea8/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubNyGwWrrNAeEQbLx67XD1MnsMWlG8Y8af_45_TBmMjjCqU } from "/codebuild/output/src4008751961/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.0.7_db0@0.3.2_eslint@9.30.0_jiti@2.4.2_1d807c0e19115dcb12ca49115f5ceea8/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "health___en",
    path: "/health",
    component: () => import("/codebuild/output/src4008751961/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/health.vue")
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src4008751961/src/bitbucket.org/magusa/cavu-workspaces/apps/_base/pages/[...slug].vue")
  },
  {
    name: "IATA-port-parking___en",
    path: "/:IATA()/port-parking",
    component: () => import("/codebuild/output/src4008751961/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/port-parking.vue")
  },
  {
    name: "IATA-airport-hotels___en",
    path: "/:IATA()/airport-hotels",
    component: () => import("/codebuild/output/src4008751961/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-hotels.vue")
  },
  {
    name: "IATA-airport-parking___en",
    path: "/:IATA()/airport-parking",
    component: () => import("/codebuild/output/src4008751961/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-parking.vue")
  },
  {
    name: "hro-code-name-IATA___en",
    path: "/hro/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src4008751961/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/hro/[code]-[name]-[IATA].vue")
  },
  {
    name: "parking-code-name-IATA___en",
    path: "/parking/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src4008751961/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/parking/[code]-[name]-[IATA].vue")
  },
  {
    name: "IATA-port-hotels-with-parking___en",
    path: "/:IATA()/port-hotels-with-parking",
    component: () => import("/codebuild/output/src4008751961/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/port-hotels-with-parking.vue")
  },
  {
    name: "IATA-airport-hotels-with-parking___en",
    path: "/:IATA()/airport-hotels-with-parking",
    component: () => import("/codebuild/output/src4008751961/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-hotels-with-parking.vue")
  },
  {
    name: "hotel-package-code-name-IATA___en",
    path: "/hotel-package/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src4008751961/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/hotel-package/[code]-[name]-[IATA].vue")
  },
  {
    name: component_45stubNyGwWrrNAeEQbLx67XD1MnsMWlG8Y8af_45_TBmMjjCqUMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubNyGwWrrNAeEQbLx67XD1MnsMWlG8Y8af_45_TBmMjjCqU
  }
]